<template>
  <div class="player-idle-phase">
    <IdleChromeShell
      :compact-layout="false"
      logo-wrap-class="player-idle-chrome-logo-wrap--registration"
      :logo-wrap-style="registrationLogoStyle"
      :hibernate="false"
    >
      <NotRegistered />
    </IdleChromeShell>
  </div>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue'
import IdleChromeShell from '@/components/IdleChromeShell.vue'
import NotRegistered from '@/components/NotRegistered.vue'
import usePlayer from '@/composables/usePlayer'
import { registrationLogoWrapStyle } from '@/helpers/playerRegistrationIdleLayout'

const { state } = usePlayer()
const { screenOrientation } = toRefs(state)

const registrationLogoStyle = computed(() =>
  registrationLogoWrapStyle(screenOrientation.value)
)
</script>
